/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Threat rating (display)
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type ThreatRatingDisplayEnum = 'Low' | 'Medium' | 'High' | 'Very High' | 'Not Applicable' | 'Not Specified';

export const ThreatRatingDisplayEnum = {
    Low: 'Low' as ThreatRatingDisplayEnum,
    Medium: 'Medium' as ThreatRatingDisplayEnum,
    High: 'High' as ThreatRatingDisplayEnum,
    VeryHigh: 'Very High' as ThreatRatingDisplayEnum,
    NotApplicable: 'Not Applicable' as ThreatRatingDisplayEnum,
    NotSpecified: 'Not Specified' as ThreatRatingDisplayEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');
marker('Not Applicable');
marker('Not Specified');

